import http from 'plugins/axios';

export default {
    getAgentList(data) {
        return http.get({
            url: '/admin/agent/queryPage',
            data
        });
    },

    getByUserId(data) {
        return http.get({
            url: '/admin/agent/getByUserId',
            data
        });
    },

    addOrUpdateAgent(data){
        return http.post({
            url: '/admin/agent/addOrUpdate',
            data
        })
    },

    deleteAgent(data){
        return http.post({
            url: '/admin/agent/delete',
            data,
            dataType:'form'
        })
    },
}
